<template>
	<div class="wrapper">
		<div v-if="label" class="header">
			<label class="label">{{label}}<span v-if="isRequired" style="font-size: 1.2em;"> *</span></label>
			<p v-if="description" class="description">{{description}}</p>
		</div>

		<slot/>

		<div v-if="isInvalid && validationMessage" class="validation-error">
			<t-timpex-icon
				class="icon"
				icon="error"
				type="bp"
				size="xs"
			/>
			<p class="text">{{validationMessage}}</p>
		</div>
		<div v-if="!isInvalid && warningMessage" class="validation-warning">
			<t-timpex-icon
				class="icon"
				icon="error"
				type="bp"
				size="xs"
			/>
			<p class="text">{{warningMessage}}</p>
		</div>
		<p v-if="hint" class="hint">{{hint}}</p>

	</div>
</template>

<script>
import inputWrapperMixin from './inputWrapperMixin.js';
export default {
	name: 'TInputWrapper',
	mixins: [inputWrapperMixin],
};
</script>

<style lang="scss" scoped>
@import './scss/input-wrapper';
</style>
